/** PURE_IMPORTS_START .._.._Observable,.._.._operator_buffer PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { buffer } from '../../operator/buffer';
Observable.prototype.buffer = buffer;
//# sourceMappingURL=buffer.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/buffer.js
// module id = ./node_modules/rxjs/_esm5/add/operator/buffer.js
// module chunks = vendor